const CURRENCIES_PLUGIN_ALIAS = 'currency';

module.exports = {
    CURRENCIES_PLUGIN_ALIAS,
};
